var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramiconelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.11,190.5a70.32,70.32,0,0,0-71.23,28.17c-15.43,21.78-14.49,53.13-.08,75.17,15.12,23.13,45.85,35.81,72.26,24.93,25.82-10.63,35-39,35.42-64.84.39-24.73-7.52-64.24-39.23-64.3-12,0-12,18.58,0,18.61,17,0,20.15,27.21,20.56,39.6.59,17.4-2,39.08-17.23,50.16-16.69,12.14-40.82,5-53.12-10-11.72-14.26-14.9-36.09-6.79-52.82,9.53-19.66,33.12-31.21,54.49-26.77,11.69,2.43,16.68-15.5,4.95-17.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.83,176.71a15.47,15.47,0,0,0,10.61-4.39,15.23,15.23,0,0,0,4.39-10.61c-.17-3.87-1.45-7.9-4.39-10.6a15,15,0,0,0-21.22,0,15.23,15.23,0,0,0-4.39,10.6c.17,3.88,1.45,7.91,4.39,10.61a15.58,15.58,0,0,0,10.61,4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,103c-66.66-20.08-130,33.58-151.48,93.29-23.15,64.25-3.7,137.2,50.77,179,52.57,40.36,128.26,39.23,178.94-4C395.4,327.79,403,252.48,388,191c-4.6-18.83-11.68-37.42-23.77-52.77-11.38-14.47-27-24.34-44.52-29.79-35.43-11-73.42-5.1-109.42-12.8-11.67-2.49-16.67,15.44-4.94,17.94,28.83,6.17,58.35,4.17,87.42,8.06,14,1.87,28,5.42,40,12.92,12.58,7.8,21.41,19.66,27.67,32.89,12.54,26.49,16.75,58.27,15.74,87.32s-8.66,58.09-25.42,82.1c-33.07,47.37-100.62,62.79-151.9,37.45-53.65-26.5-83.35-86.2-73.53-145,5.59-33.46,21.87-65,48.22-86.72,24.25-20,56.87-30.87,87.71-21.58,11.49,3.46,16.4-14.49,4.94-17.94Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramiconelement);
export default __webpack_public_path__ + "static/media/Instagram icon element.0a434e16b5499769fa24811623def5bb.svg";
export { ForwardRef as ReactComponent };